import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatServiceProcedure',
})

export class FormatServiceProcedurePipe implements PipeTransform {

    public transform(value: any, ...args: any[]): any {
        if (!value) {
            return '';
        }

        return `${value.customCode || value.code} - ${value.customName || value.description || value.procedure?.description || ''}`;
    }

}
